import { render, staticRenderFns } from "./ExpireMessage.vue?vue&type=template&id=4fa66afe&scoped=true&"
import script from "./ExpireMessage.vue?vue&type=script&lang=js&"
export * from "./ExpireMessage.vue?vue&type=script&lang=js&"
import style0 from "./ExpireMessage.vue?vue&type=style&index=0&id=4fa66afe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa66afe",
  null
  
)

export default component.exports